import { render, staticRenderFns } from "./schoolNewDataList.vue?vue&type=template&id=6360afdb&scoped=true"
import script from "./schoolNewDataList.vue?vue&type=script&lang=js"
export * from "./schoolNewDataList.vue?vue&type=script&lang=js"
import style0 from "./schoolNewDataList.vue?vue&type=style&index=0&id=6360afdb&prod&lang=scss&scoped=true"
import style1 from "./schoolNewDataList.vue?vue&type=style&index=1&id=6360afdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6360afdb",
  null
  
)

export default component.exports